import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleQuote24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSpeechBubbleQuote24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 18.044v-1.5H5a1.5 1.5 0 0 1-1.5-1.5V7A1.5 1.5 0 0 1 5 5.5h14A1.5 1.5 0 0 1 20.5 7v8.044a1.5 1.5 0 0 1-1.5 1.5h-6.507l-.402.307L8 19.97zm11 0h-6l-4.894 3.731A1 1 0 0 1 6.5 20.98v-2.936H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8.044a3 3 0 0 1-3 3m-8.174-8.118a.75.75 0 0 0-.65-1.352l.315.656-.316-.656-.003.002-.005.002-.014.007a3 3 0 0 0-.202.109 5 5 0 0 0-.481.314c-.344.254-.837.69-1.063 1.292-.195.52-.234 1.11-.236 1.522 0 .19.006.358.015.487l-.004.11a1.545 1.545 0 1 0 1.613-1.545l.016-.047c.07-.186.273-.407.55-.613a3.5 3.5 0 0 1 .438-.275l.024-.012zm4.637 0a.75.75 0 0 0-.65-1.352l.314.656-.315-.656h-.001l-.002.002-.005.002-.015.007a4 4 0 0 0-.201.109 5 5 0 0 0-.482.314c-.344.254-.837.69-1.063 1.292-.195.52-.234 1.11-.236 1.522 0 .19.007.358.015.487l-.004.11a1.545 1.545 0 1 0 1.613-1.545l.017-.047c.07-.186.272-.407.55-.613a3.5 3.5 0 0 1 .437-.275l.024-.012z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleQuote24);
